var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinSmallMarkerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 53,
    viewBox: "0 0 40 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.2471,
    r: 20,
    fill: "#F6A72D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6225 11.8623C15.1799 11.8623 14.4574 13.6065 15.4775 14.6266C15.7812 14.9303 15.9518 15.3421 15.9518 15.7716L15.9518 17.6687C15.9518 18.0982 15.7812 18.51 15.4775 18.8137C14.4574 19.8338 15.1799 21.578 16.6225 21.578L19.4041 21.578L19.4041 28.0365C19.4041 28.3657 19.6709 28.6325 20 28.6325C20.3291 28.6325 20.596 28.3657 20.596 28.0365V21.578L23.3775 21.578C24.8201 21.578 25.5426 19.8338 24.5225 18.8137C24.2188 18.51 24.0482 18.0982 24.0482 17.6687L24.0482 15.7716C24.0482 15.3421 24.2188 14.9303 24.5225 14.6266C25.5426 13.6065 24.8201 11.8623 23.3775 11.8623L16.6225 11.8623Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.644 43.8248C20.8476 44.935 19.1972 44.9376 18.3974 43.8298L14.7892 38.8321C13.8342 37.5094 14.7793 35.6614 16.4107 35.6614L23.604 35.6614C25.2326 35.6614 26.1784 37.5038 25.2291 38.8271L21.644 43.8248Z",
    fill: "#F6A72D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4551 47.9241C19.6266 47.3963 20.3734 47.3963 20.5449 47.9241C20.6216 48.1602 20.8416 48.32 21.0898 48.32C21.6448 48.32 21.8756 49.0303 21.4266 49.3565C21.2258 49.5024 21.1417 49.761 21.2184 49.9971C21.39 50.5249 20.7858 50.9639 20.3368 50.6376C20.136 50.4917 19.864 50.4917 19.6632 50.6376C19.2142 50.9639 18.61 50.5249 18.7816 49.9971C18.8583 49.761 18.7742 49.5024 18.5734 49.3565C18.1244 49.0303 18.3552 48.32 18.9102 48.32C19.1584 48.32 19.3784 48.1602 19.4551 47.9241Z",
    fill: "#F6A72D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSmallMarkerIcon);
export default __webpack_public_path__ + "static/media/pinSmallMarkerIcon.c0db880803e539a95471b785f8d37624.svg";
export { ForwardRef as ReactComponent };